import { defineMessages } from 'react-intl';

export default defineMessages({
    quoteNumber: {
        id: 'quoteandbind.views.wizardSidebar.Quote Number',
        defaultMessage: 'Quote Number',
    }
});
